import {combineReducers,configureStore} from "@reduxjs/toolkit";
import appSlice from "./slices/appSlice";
import authSlice from "./slices/auth/authSlice";
import participantsSlice from "./slices/participants/participantsSlice";

const rootReducer = combineReducers({
    app: appSlice,
    auth: authSlice,
    participants: participantsSlice,
});

export const store = configureStore({
    reducer: rootReducer
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch